export default __webpack_public_path__ + "static/media/service3bg.7a1d7108.webp";